import {
  Avatar,
  Box,
  Card,
  CardActions,
  CardMedia,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  Fab,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
  Typography
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { BIBlue } from "../../assets/helpers";
import PlaceholderImg from "../../assets/images/avtar_placeholder.jpeg";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import GroupIcon from "@mui/icons-material/Group";
import ErrorIcon from "@mui/icons-material/Error";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../../common/Loader";

function SharedWithMeTab({
  sharedData,
  hasMoreShared,
  loadMoreShared,
  handleMessage,
  handleExpandAccordian,
  handleSelectAllShared,
  isExpired,
  handleViewClick,
  handleToggleSharedSingleTicket,
  setTicketFlag,
  supervisorSharedData,
  supervisorLoading,
  supervisorHasMore,
  loadMoreSupervisorShared
}) {
  const { loginData } = useSelector((state) => state?.main);
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    if (status === "Accepted") return "success";
    if (status === "Rejected") return "error";
    return "warning";
  };

  if (supervisorLoading) return <Loader />;

  return (
    <>
      {/* Shared with Me as Supervisor */}
      {supervisorSharedData.length > 0 && (
        <>
          <Typography sx={{ color: BIBlue,  fontWeight: 600, py: 1 }} variant="body2" >
            Shared with Me (Supervisor)
          </Typography>
          <InfiniteScroll
            dataLength={supervisorSharedData.length}
            next={loadMoreSupervisorShared}
            hasMore={supervisorHasMore}
            scrollableTarget="scrollableTicketList"
            loader={
              <Box sx={{ textAlign: "center", py: 1 }}>
                <CircularProgress size={20} />
              </Box>
            }>
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {supervisorSharedData.map((item, index) => (
                  <Card key={index} className="pagelist-content" sx={{ marginTop: "0px" }}>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() =>
                          navigate(`/user-tickets/${item.userId}`, {
                            state: { status: item.status, userInfo: item }
                          })
                        }>
                        <ListItemAvatar>
                          <Avatar src={item?.pictureUrl || PlaceholderImg} alt={item?.userName} />
                        </ListItemAvatar>
                        <ListItemText sx={{ pl: 1, fontWeight: 600 }} primary={ <Typography variant="body1">
                              {item?.userName}
                            </Typography>
                          }
                          secondary={item?.userEmail}
                        />
                        <Chip
                          label={item?.status}
                          color={getStatusColor(item?.status)}
                          size="small"
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                ))}
              </Stack>
            </List>
          </InfiniteScroll>
        </>
      )}

      {/* Shared with Me */}
      {sharedData?.length > 0 && (
        <>
          <Typography sx={{ color: BIBlue,  fontWeight: 600, py: 1 }} variant="body2" >
            Shared with Me (BI User)
          </Typography>
          <InfiniteScroll
            dataLength={sharedData.length}
            next={loadMoreShared}
            hasMore={hasMoreShared}
            scrollableTarget="scrollableTicketList"
            loader={
              <Box sx={{ textAlign: "center", py: 1 }}>
                <CircularProgress size={20} />
              </Box>
            }>
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {sharedData?.map((item, index) => (
                  <Card
                    key={index.toString()}
                    className="pagelist-content"
                    sx={{ marginTop: "0px" }}>
                    <ListItem sx={{ m: 0, alignItems: "center" }} disablePadding secondaryAction={ <Stack direction={"row"} spacing={1}>
                          <IconButton onClick={(e) => handleExpandAccordian(e, item)}>
                            {item?.isExpanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                          </IconButton>
                        </Stack>
                      }>
                      <ListItemButton onClick={(e) => handleExpandAccordian(e, item)}>
                        <ListItemAvatar
                          onClick={(e) => {
                            handleSelectAllShared(e, item);
                          }}>
                          {item.isAllSelected ? (
                            <Fab color="primary" size="small" sx={{ boxShadow: "none" }}>
                              <CheckIcon />
                            </Fab>
                          ) : (
                            <Avatar
                              alt="contact-PictureUrl"
                              src={
                                item?.ticketOwnerPicture != ""
                                  ? item?.ticketOwnerPicture
                                  : PlaceholderImg
                              }
                            />
                          )}
                        </ListItemAvatar>
                        <ListItemText
                          sx={{ pl: 1 }}
                          primary={
                            <Typography variant="body1">
                              {item?.name} ({item?.tickets?.length})
                            </Typography>
                          }
                          secondary={item?.ticketOwnerEmail}
                        />
                      </ListItemButton>
                    </ListItem>
                    {item?.isExpanded && (
                      <>
                        <Divider />
                        <Box sx={{ p: 2 }}>
                          <Grid container spacing={{ xs: 1.5, md: 2 }}>
                            {item?.tickets?.map((ticket, index) => (
                              <Grid key={index} size={{ xs: 12, sm: 6, md: 6, lg: 4, xl: 3 }}>
                                <Card
                                  className="pagelist-content"
                                  sx={{
                                    backgroundColor:
                                      isExpired(ticket.expiry) === true ? "#FABEBE" : ""
                                  }}>
                                  <CardMedia
                                    component="img"
                                    height="200"
                                    image={ticket?.frontPictureUrl}
                                    alt="Front Picture"
                                    sx={{ cursor: "pointer" }}
                                    onClick={() => {
                                      handleViewClick(ticket);
                                      setTicketFlag("shareTab");
                                    }}
                                  />
                                  <CardActions
                                    disableSpacing
                                    sx={{ flexDirection: "column", alignItems: "baseline" }}>
                                    <Stack
                                      sx={{
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%"
                                      }}>
                                      <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                                        <Checkbox
                                          color="primary"
                                          checked={ticket.isSelected}
                                          onChange={(e) =>
                                            handleToggleSharedSingleTicket(e, item, ticket.id)
                                          }
                                          inputProps={{ "aria-label": "controlled" }}
                                          sx={{ color: BIBlue, padding: "5px" }}
                                        />
                                        <Typography variant="body1" maxWidth={"170px"} noWrap>
                                          {ticket?.ticketType}
                                        </Typography>
                                      </Stack>
                                      <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                                        {isExpired(ticket.expiry) === true && (
                                          <IconButton
                                            color="secondary"
                                            size="small"
                                            onClick={() => handleMessage("ErrorIcon")}>
                                            <ErrorIcon fontSize="small" sx={{ color: "#ef4444" }} />
                                          </IconButton>
                                        )}
                                        {ticket.sharedTicketsList?.length !== 0 && (
                                          <IconButton
                                            color="default"
                                            size="small"
                                            onClick={() => handleMessage("GroupIcon")}>
                                            <GroupIcon fontSize="small" />
                                          </IconButton>
                                        )}
                                      </Stack>
                                    </Stack>
                                    <Typography sx={{ pl: 1 }} variant="body1" maxWidth={"250px"} noWrap>
                                      {ticket?.issuedBy}
                                    </Typography>
                                  </CardActions>
                                </Card>
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      </>
                    )}
                  </Card>
                ))}
              </Stack>
            </List>
          </InfiniteScroll>
        </>
      )}
    </>
  );
}

export default SharedWithMeTab;

